import { connect } from 'react-redux'
import { AllState } from '../../../../store'
import ReloadButton from '../../../components/buttons/ReloadButton'
import SubmitButton from '../../../components/buttons/SubmitButton'
import CancelConfirmDialog from '../../../components/dialogs/CancelConfirmDialog'
import PageHeader, {
  HeaderContent,
  HeaderDivider,
  HeaderGroup,
  IconGroup,
} from '../../../components/headers/HeaderBar/PageHeader'
import SettingSpeedDial, {
  SettingSpeedDialProps,
} from '../../../components/headers/HeaderBar/SettingSpeedDial'
import {
  ToolbarToggleGroup,
  ToolbarToggleValue,
} from '../../../components/toolbars/Toolbar/ToolbarToggle'
import TeamSelect from '../../../components/editors/select/TeamSelect'
import QuickFilterToggleButtons from './QuickFilterToggleButtons'
import { QuickFilterKey } from '../SprintOptions'
import { useDialogState } from '../../../components/dialogs/useDialogState'

interface OwnProps {
  toolbar: ToolbarToggleValue | undefined
  onChangeToolbar: (value: ToolbarToggleValue | undefined) => void
  isNotice: boolean
  onSubmit: () => void
  submitDisabled: boolean
  isLoading: boolean
  onCancel: () => void
  quickFilters: QuickFilterKey[]
  onChangeQuickFilters: (values: QuickFilterKey[]) => void
  projectUuid: string | undefined
  onTeamChanged: (teamUuid: string) => void
  teamUuid?: string
}

interface StateProps {
  notEdited: boolean
}

type Props = OwnProps & StateProps & SettingSpeedDialProps

const SprintHeader = ({
  onSubmit,
  submitDisabled,
  isLoading,
  notEdited,
  onCancel,
  onClickExport,
  rowHeight,
  onClickChangeRowHeight,
  onChangeToolbar,
  toolbar,
  isNotice,
  onRestoreSearchCondition,
  quickFilters,
  onChangeQuickFilters,
  projectUuid,
  onTeamChanged,
  teamUuid,
  currentFormat,
  onClickChangeDateFormat,
}: Props) => {
  const [showCancelDialog, openCancelDialog, closeCancelDialog] =
    useDialogState()

  return (
    <PageHeader>
      <HeaderContent>
        <TeamSelect
          projectUuid={projectUuid!}
          onTeamChanged={onTeamChanged}
          teamUuid={teamUuid}
        />
        <HeaderGroup>
          <SubmitButton
            onClick={onSubmit}
            disabled={submitDisabled || isLoading || notEdited}
            notEdited={notEdited}
          />
          <ReloadButton onClick={openCancelDialog} disabled={isLoading} />
          <CancelConfirmDialog
            open={showCancelDialog}
            onConfirm={() => {
              closeCancelDialog()
              onCancel()
            }}
            onClose={closeCancelDialog}
          />
        </HeaderGroup>
        <HeaderDivider />
        <HeaderGroup>
          <IconGroup>
            <SettingSpeedDial
              onClickExport={onClickExport}
              rowHeight={rowHeight}
              onClickChangeRowHeight={onClickChangeRowHeight}
              onRestoreSearchCondition={onRestoreSearchCondition}
              currentFormat={currentFormat}
              onClickChangeDateFormat={onClickChangeDateFormat}
            />
          </IconGroup>
        </HeaderGroup>
        <ToolbarToggleGroup
          toggleItems={[ToolbarToggleValue.DISPLAY]}
          value={toolbar}
          onChange={onChangeToolbar}
          noticeItem={ToolbarToggleValue.DISPLAY}
          isNotice={isNotice}
        />
        <HeaderGroup>
          <QuickFilterToggleButtons
            quickFilters={quickFilters}
            onChangeQuickFilters={onChangeQuickFilters}
          />
        </HeaderGroup>
      </HeaderContent>
    </PageHeader>
  )
}

const mapStateToProps = (state: AllState) => ({
  notEdited: !state.hasRequiredSaveData.hasRequiredSaveData,
})

export default connect(mapStateToProps)(SprintHeader)
